export const plpPageConstants = {
  SORT_BY: "Sort By",
  FILTER: "Filters",
  RECOMMENDED: "Recommended",
  NOT_FILTER: "No Filter applied",
  APPLIED: "Applied",
  TO: "to",
  INITIAL_PAGE: 0,
  DESKTOP_PRODUCT_PER_PAGE: 20,
  MOBILE_PRODUCT_PER_PAGE: 8,
  OUT_OF_STOCK: "OUT OF STOCK",
  EARLIEST_DELIVERY: "Earliest Delivery",
  FNP_NOW_ICON: "/icons/fnp-now-1.svg",
  FNP_TODAY_ICON: "/icons/fnp-today.svg",
  SAME_DAY_PLP: "/icons/same-day-plp.svg",
  DELIVERY_CLOCK_ICON: "/icons/clock-3.svg",
  DELIVERY_CALENDAR_ICON: "/icons/calendarblank-1.svg",
  DELIVERY_BIKE_ICON: "/icons/moped-1.svg",
  MORNING_DELIVERY_ICON: "/icons/morning-delivery.svg",
  SORT: "Sort",
  NO_PRODUCT_MATCH_FOUND: "No product match found.",
  NO_PRODUCT_FOUND: "No Products Found",
  NO_PRODUCT_IN_THIS_CATEGORY_FOR_YOUR_LOCATION: "No products in this category for your location",
  VIEW_AVAILABLE_GIFT_FOR: "View available gifts for",
  NOT_SERVICEABLE: "This gift isn't available at the selected pincode",
  WE_ARE_SORRY: "Don't worry, you can check out other available gifts",
  EXPLORE_SIMILAR_GIFTS: "Explore Similar Gifts",
  CHANGE_DELIVERY_PINCODE: "Change Delivery Pincode/Area",
  WE_COULD_NOT_FIND_ANY_PRODUCTS: "We could not find any products for your selected criteria",
  RESET_FILTERS: "RESET FILTERS",
  NOT_SERVICABLE_CATEGORY: "No products found in this category",
  VIEW_AVAILABLE_GIFT: "View available gifts",
  SEE_ALL_AVAILABLE_PRODUCTS: "See all available products at ",
  SEARCH: "search",
  NO_RESULT_FOUND: "Sorry, No Results Found.",
  TRY_SOMETHING_ELSE: "Please try searching for something else.",
  SEARCH_INSTEAD: "Search Instead",
  SEARCH_TITLE: "Popular Search  - FNP",
  SHOW_RESULTS: "Show Results",
  APPLY: "Apply",
  SEARCH_RESULTS_FOR: "Showing results for",
  AndAbove: "and Above",
  Asterisk: "*",
  SORT_BY_ID: "sort_by",
  FILTER_ID: "filters",
};

export const plpBannerConstants = {
  PLP_BANNER: "PLP Banner",
  CODE_COPIED: "Code Copied",
  USE_CODE: "Use Code",
  HRS: "Hrs",
  MIN: "Min",
  SEC: "Sec",
};

export const plpCleverTapEvents = {
  PAGE_VIEWED: "PLP Page Viewed",
  PRODUCT_CLICKED: "Product Clicked",
  PAGE_SCROLLED: "Page Scrolled",
  SORT_SELECTED: "Sort Selected",
  FILTER_SELECTED: "Filter Selected",
  FILTER_APPLIED: "Filter Applied",
  PRODUCT_IMPRESSION: "Product Impression",
  EARLIEST_DELIVERY_DATE_SHOWN: "Earliest Delivery Date Viewed",
  FILTER_VIEWED: "Filter Viewed",
};

export const PLP_PRODUCT_VIDEO_POSITION = 0;
